import React from 'react';
import { useParams } from 'react-router-dom';
import { extractIdFromPath } from '@/utils';
import Realm from './Realm';

export default function RealmWrapper() {
    const { realmPath } = useParams();
    return <Realm realmId={extractIdFromPath(realmPath)} />;
}
